import { render, staticRenderFns } from "./sticky-messages.vue?vue&type=template&id=4b1467ab"
import script from "./sticky-messages.vue?vue&type=script&lang=js"
export * from "./sticky-messages.vue?vue&type=script&lang=js"
import style0 from "./sticky-messages.vue?vue&type=style&index=0&id=4b1467ab&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports